module.exports = __webpack_public_path__ + "static/media/061-saba-island.e25d442b.svg";